import { Table } from './Table'
import { withTable } from './withTable'

const ConnectedTable = withTable<any>(Table)
export { ConnectedTable as Table }
